import { Environment } from '@core/models/global.models';

const production: Environment = {
  appName: 'Direct Connections',
  production: true,
  apiConfig: {
    cashProcessorUrl:
      'https://experience.cash.monnet.io/api/v1/ms-experience-monnet-cash/payment/voucher',
    payinCheckoutBackendUrl:
      'https://payin.experience.monnet.io/api/v1/payin-checkout-experience/',
    voucherPayinExperienceUrl:
      'https://experience.cash.monnet.io/api/v1/ms-experience-monnet-cash/transaction/voucher-data/',
    webSocket:
      'wss://payin.experience.monnet.io/api/v1/payin-checkout-experience/ws',
    payinMetricExperienceUrl: 'https://payin.experience.monnet.io/ms-payin-metric-experience'
  }
};

export const environment = production;
